import React from "react";
import { t } from "ttag";

import { format } from "../../../utils/format";
import { Dinero } from "../../../utils/money";

import styles from "./common.module.scss";

export const RecyclingFeeRow = (props: {
    recyclingFee: Dinero;
}): React.ReactNode => (
    <div className={styles.line}>
        <div>{t`Recycling Fee`}</div>
        <div>{format.money(props.recyclingFee)}</div>
    </div>
);
